(function() {

var hideTimeout = false, $hideEl;

$("body").on("mouseover", "#navigation .ext", function(e) {
	// if hovered back on currently hiding element, stop hiding
	if($hideEl && $(this).is($hideEl)) {
		// e.stopPropagation();
		clearTimeout(hideTimeout)
	}
})

var oldShowSubmenu = shoptet.menu.showSubmenu;
function showSubmenu($el) {
	clearTimeout(hideTimeout);
	oldHideSubmenu();

	oldShowSubmenu($el);
}
shoptet.scripts.registerFunction(showSubmenu, "menu")

var oldHideSubmenu = shoptet.menu.hideSubmenu;
function hideSubmenu() {
	var $hiding = $hideEl = $("#navigation .ext.exp");

	// hide after delay
	clearTimeout(hideTimeout);
	hideTimeout = setTimeout(function() {
		if($hideEl === $hiding) // only clear if same instance
			$hideEl = null;

		oldHideSubmenu();
	}, 500);
}
shoptet.scripts.registerFunction(hideSubmenu, "menu");

})();